import { Image, MessageCircle, Music3 } from "lucide-react";
import { Reveal } from "../components/Reveal";

const blocks = [
  { icon: Image, title: "Klare Bilder", text: "Große, ruhige Illustrationen konzentrieren sich auf das Wesentliche.", color: "#D95338", soft: "#FDF2EF" },
  { icon: MessageCircle, title: "Einfache Sprache", text: "Kurze, verständliche Begriffe laden zum gemeinsamen Benennen ein.", color: "#3A7BD5", soft: "#EEF4FC" },
  { icon: Music3, title: "Lernen mit Musik", text: "Passende Lernlieder laden zum Mitsingen, Klatschen und Bewegen ein.", color: "#4A8B5D", soft: "#F0F6F2" },
];

export const Why = () => (
  <section className="py-24 sm:py-32" style={{ background: "var(--paper-deep)" }} data-testid="why-section">
    <div className="max-w-5xl mx-auto px-5 lg:px-8">
      <Reveal className="text-center mb-14">
        <p className="eyebrow-label mb-5">Warum VisualMA</p>
        <h2 className="font-display font-medium tracking-tight text-4xl sm:text-5xl leading-[1.08] mb-5">
          Einfach. Gemeinsam.<br />
          <em style={{ color: "var(--terra)" }}>Mit Freude.</em>
        </h2>
        <p className="text-[15px] sm:text-base text-[color:var(--ink-muted)] max-w-md mx-auto">
          Frühes Lernen muss nicht kompliziert sein.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-12">
        {blocks.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.1}>
            <div className="card-soft p-8 h-full text-left transition-transform duration-500 hover:-translate-y-1.5" data-testid={`why-block-${i + 1}`}>
              <span
                className="w-14 h-14 flex items-center justify-center mb-6"
                style={{ background: b.soft, color: b.color, borderRadius: "56% 44% 52% 48% / 46% 54% 46% 54%" }}
              >
                <b.icon size={24} strokeWidth={1.6} />
              </span>
              <p className="text-[11px] uppercase tracking-[0.22em] font-semibold mb-3" style={{ color: b.color }}>
                {b.title}
              </p>
              <p className="text-[15px] text-[color:var(--ink-muted)] leading-relaxed">{b.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15} className="text-center">
        <p className="font-display italic text-lg sm:text-xl text-[color:var(--ink)] max-w-xl mx-auto leading-relaxed">
          VisualMA ist für gemeinsame Lernmomente gedacht – nicht dafür, dass kleine Kinder alleine
          lesen.
        </p>
      </Reveal>
    </div>
  </section>
);
